import { useContext } from 'react';
import { RegionContext, RegionContextData } from './context';

export function useRegion(): RegionContextData {
    const data = useContext<RegionContextData | undefined>(RegionContext);

    if (!data) {
        throw new Error(
            "Region unavailable. Are you sure you're using this in a nested component of a RegionProvider?"
        );
    }

    return data;
}
